'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function BBFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-fk9zymus7", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-fk9zymus7)" }, /* @__PURE__ */ React.createElement("path", { fill: "#2e42a5", d: "M22 0h10v24H22z" }), /* @__PURE__ */ React.createElement("path", { fill: "#feca00", d: "M10 0h12v24H10z" }), /* @__PURE__ */ React.createElement("path", { fill: "#2e42a5", d: "M0 0h10v24H0z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#000",
        d: "M18.612 15.668c.188-1.29 1.52-4.093 1.52-4.093l.619-1.644-2.45.795.58.301-1.135 3.199-.857-.205V7.853l.678-.05-1.672-2.431-1.632 2.48h.788v6.17l-.966.16-.688-3.234.397-.333-2.665-.492.796 1.469s1.07 2.516 1.472 4.076l1.654-.128v2.397h1.838V15.54z"
      }
    )))
  );
}

export { BBFlag };
//# sourceMappingURL=BB.mjs.map
